/* CORIA FUTURE 2026 — interactiuni. Fiecare efect porneste doar daca clasa lui
   (cf-*) e pe <body>, adica daca e bifat in Setari tema → "✦ Coria Future". */
(function () {
  'use strict';
  var body = document.body;
  var shopRoot=(window.Shopify&&window.Shopify.routes&&window.Shopify.routes.root)||'/';
  var route=function(path){return shopRoot+path.replace(/^\//,'');};
  if (!body || !body.classList.contains('cf-on')) return;
  document.documentElement.classList.add('cf-js');

  var has = function (c) { return body.classList.contains(c); };
  var TX = window.CF_TEXT || {};
  var tx = function (k, d) { return (TX[k] !== undefined && TX[k] !== null) ? TX[k] : d; };
  var addLbl = function () { var t = String(tx('add', 'Adauga in cos')), k = t.indexOf(' '); return k < 0 ? t : t.slice(0, k) + '<em class="cf-atc__rest">' + t.slice(k) + '</em>'; };
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var conn = navigator.connection || {};
  var coarse = window.matchMedia('(pointer: coarse)').matches;
  var lite = reduce || !!conn.saveData || /2g/.test(conn.effectiveType || '') ||
    (navigator.deviceMemory && navigator.deviceMemory <= 4) ||
    (coarse && navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 6) ||
    (coarse && Math.min(screen.width, screen.height) >= 600 && navigator.hardwareConcurrency && navigator.hardwareConcurrency <= 8);
  if (lite) document.documentElement.classList.add('cf-lite');
  document.addEventListener('visibilitychange', function () {
    document.documentElement.classList.toggle('cf-hidden', document.hidden);
  });
  var finePointer = window.matchMedia('(hover: hover) and (pointer: fine)').matches;


  /* ---------- Text fara diacritice la afisare (continutul din Shopify ramane neschimbat) ---------- */
  if (has('cf-nodia')) {
    var DIA = /[ăâîșşțţĂÂÎȘŞȚŢ]/g;
    var DMAP = { 'ă': 'a', 'â': 'a', 'î': 'i', 'ș': 's', 'ş': 's', 'ț': 't', 'ţ': 't',
      'Ă': 'A', 'Â': 'A', 'Î': 'I', 'Ș': 'S', 'Ş': 'S', 'Ț': 'T', 'Ţ': 'T' };
    var SKIP = { SCRIPT: 1, STYLE: 1, TEXTAREA: 1, NOSCRIPT: 1, CODE: 1, PRE: 1 };
    var fixText = function (t) { return t.replace(DIA, function (c) { return DMAP[c]; }); };
    var fixNode = function (root) {
      if (!root) return;
      if (root.nodeType === 3) {
        if (DIA.test(root.nodeValue)) { DIA.lastIndex = 0; root.nodeValue = fixText(root.nodeValue); }
        DIA.lastIndex = 0;
        return;
      }
      if (root.nodeType !== 1 || SKIP[root.tagName] || root.isContentEditable) return;
      var w = document.createTreeWalker(root, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) {
          var p = n.parentNode;
          if (!p || SKIP[p.nodeName] || (p.isContentEditable)) return NodeFilter.FILTER_REJECT;
          return NodeFilter.FILTER_ACCEPT;
        }
      });
      var n;
      while ((n = w.nextNode())) {
        var v = n.nodeValue;
        if (v && v.search(DIA) !== -1) n.nodeValue = fixText(v);
      }
      root.querySelectorAll && root.querySelectorAll('[placeholder],[title],[aria-label],[alt]').forEach(function (el) {
        ['placeholder', 'title', 'aria-label', 'alt'].forEach(function (a) {
          var v = el.getAttribute(a);
          if (v && v.search(DIA) !== -1) el.setAttribute(a, fixText(v));
        });
      });
    };
    (window.requestIdleCallback || function (f) { return setTimeout(f, 200); })(function () { fixNode(body); }, { timeout: 1500 });
    if (document.title.search(DIA) !== -1) document.title = fixText(document.title);
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        if (m.type === 'characterData') {
          if (m.target.nodeValue && m.target.nodeValue.search(DIA) !== -1 && !SKIP[(m.target.parentNode || {}).nodeName]) m.target.nodeValue = fixText(m.target.nodeValue);
        } else {
          m.addedNodes.forEach(fixNode);
        }
      });
    }).observe(body, { childList: true, subtree: true });
  }

  /* ---------- Textura de film (strat separat, nu atinge suprapunerile temei) ---------- */
  if (has('cf-grain') && !lite) {
    var grain = document.createElement('div');
    grain.className = 'cf-grain-layer';
    grain.setAttribute('aria-hidden', 'true');
    body.appendChild(grain);
  }

  /* ---------- Scroll: bara progres + stare header ---------- */
  var bar = null;
  if (has('cf-progress')) {
    bar = document.createElement('div');
    bar.className = 'cf-progress-bar';
    bar.setAttribute('aria-hidden', 'true');
    body.appendChild(bar);
  }
  var ticking = false;
  function onScroll() {
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () {
      var y = window.scrollY || document.documentElement.scrollTop;
      body.classList.toggle('cf-scrolled', y > 24);
      if (bar) {
        var max = document.documentElement.scrollHeight - window.innerHeight;
        bar.style.setProperty('--cf-scroll', max > 0 ? Math.min(1, y / max).toFixed(4) : 0);
      }
      ticking = false;
    });
  }
  window.addEventListener('scroll', onScroll, { passive: true });
  onScroll();

  /* ---------- Aparitie la scroll ---------- */
  var REVEAL = [
    '.product--card',
    '.section--header',
    '.media-grid--item',
    '.collections-tab--menu-content-item-box',
    '.scrolling-collections-item',
    '.trending-products--list-item',
    '.product-grid-card',
    '.collection--card',
    '.blog--card',
    '.multicolumn--item'
  ].join(',');

  var io = null;
  if (has('cf-reveal') && !reduce && 'IntersectionObserver' in window) {
    io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) {
          e.target.classList.add('cf-in');
          io.unobserve(e.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
  }

  function prepReveal(root) {
    if (!io) return;
    var groups = new Map();
    /* v19.7 viteza: intai citim toate pozitiile, apoi scriem clasele (fara recalculari fortate in bucla) */
    var vh = window.innerHeight, vw = window.innerWidth, list = [];
    (root || document).querySelectorAll(REVEAL).forEach(function (el) {
      if (el.classList.contains('cf-rv') || el.closest('.side-drawer, .quickview-product, .cf-rv, .swiper, .swiper-wrapper, [class*="swiper"]')) return;
      list.push([el, el.getBoundingClientRect()]);
    });
    list.forEach(function (it) {
      var el = it[0], r = it[1];
      // ce e deja vizibil la incarcare nu se mai ascunde (fara "palpaire")
      if (r.top < vh * 0.92 && r.bottom > 0 && r.left < vw && r.right > 0 && !root) {
        el.classList.add('cf-rv', 'cf-in');
        return;
      }
      var parent = el.parentElement;
      var n = groups.get(parent) || 0;
      groups.set(parent, n + 1);
      el.style.setProperty('--cf-d', Math.min(n % 6, 5));
      el.classList.add('cf-rv');
      io.observe(el);
    });
  }

  /* apare tot ce a trecut de marginea de jos a ecranului (si la scroll rapid / salturi) */
  if (io) {
    var sweepRaf = 0;
    var sweep = function () {
      sweepRaf = 0;
      var limit = window.innerHeight * 1.05;
      var hit = [];
      document.querySelectorAll('.cf-rv:not(.cf-in)').forEach(function (el) {
        if (el.getBoundingClientRect().top < limit) hit.push(el);
      });
      hit.forEach(function (el) { el.classList.add('cf-in'); io.unobserve(el); });
    };
    /* viteza: IntersectionObserver face treaba la derulare; plasa "sweep" ruleaza doar dupa ce derularea se opreste si doar daca mai e ceva ascuns */
    var sweepT = 0;
    window.addEventListener('scroll', function () {
      clearTimeout(sweepT);
      sweepT = setTimeout(function () { if (!sweepRaf && document.querySelector('.cf-rv:not(.cf-in)')) sweepRaf = requestAnimationFrame(sweep); }, 180);
    }, { passive: true });
    // plasa de siguranta: dupa 2,5 s de la incarcare totul e vizibil
    var revealAll = function () {
      document.querySelectorAll('.cf-rv:not(.cf-in)').forEach(function (el) { el.classList.add('cf-in'); });
    };
    window.addEventListener('load', function () { setTimeout(revealAll, 2500); });
    setTimeout(revealAll, 6000);
  }

  /* ---------- Carduri: lumina + inclinare 3D ---------- */
  function bindCards(root) {
    if (!finePointer || reduce) return;
    var spot = has('cf-spotlight');
    var tilt = has('cf-tilt');
    if (!spot && !tilt) return;
    (root || document).querySelectorAll('.product--card-inner:not([data-cf-card])').forEach(function (card) {
      card.setAttribute('data-cf-card', '');
      var raf = 0;
      card.addEventListener('pointermove', function (ev) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var r = card.getBoundingClientRect();
          var x = (ev.clientX - r.left) / r.width;
          var y = (ev.clientY - r.top) / r.height;
          if (spot) {
            card.style.setProperty('--cf-mx', (x * 100).toFixed(1) + '%');
            card.style.setProperty('--cf-my', (y * 100).toFixed(1) + '%');
          }
          if (tilt) {
            card.style.setProperty('--cf-rx', ((0.5 - y) * 6).toFixed(2) + 'deg');
            card.style.setProperty('--cf-ry', ((x - 0.5) * 7).toFixed(2) + 'deg');
          }
        });
      });
      card.addEventListener('pointerleave', function () {
        card.style.removeProperty('--cf-rx');
        card.style.removeProperty('--cf-ry');
      });
    });
  }

  /* ---------- Unda la apasare ---------- */
  if (has('cf-ripple') && !reduce) {
    var RIPPLE = '.button, .bm-quick-buy-button, .swiper-button, .footer-newsletter-button';
    document.addEventListener('pointerdown', function (ev) {
      var el = ev.target.closest && ev.target.closest(RIPPLE);
      if (!el) return;
      var cs = getComputedStyle(el);
      if (cs.position === 'static' || cs.overflow === 'visible') return; // nu stricam layout-ul
      var r = el.getBoundingClientRect();
      var dot = document.createElement('span');
      dot.className = 'cf-ripple-dot';
      dot.style.left = ev.clientX - r.left + 'px';
      dot.style.top = ev.clientY - r.top + 'px';
      el.appendChild(dot);
      setTimeout(function () { dot.remove(); }, 750);
    }, { passive: true });
  }

  /* ---------- Puls pe cos cand se adauga un produs ---------- */
  if (has('cf-cartpulse')) {
    var bump = function () {
      var icon = document.querySelector(
        '.header--icons-list a[href*="/cart"], .header--icons-list [data-cart-drawer], .header--icons-list .cart-icon, .header--icons-list li:last-child > a, .header--icons-list li:last-child > button'
      );
      if (!icon) return;
      if (getComputedStyle(icon).position === 'static') icon.style.position = 'relative';
      icon.classList.remove('cf-cart-bump');
      void icon.offsetWidth;
      icon.classList.add('cf-cart-bump');
      setTimeout(function () { icon.classList.remove('cf-cart-bump'); }, 1100);
    };
    // Observam cererile catre /cart/add fara a modifica raspunsurile
    if (window.PerformanceObserver) {
      try {
        new PerformanceObserver(function (list) {
          list.getEntries().forEach(function (e) {
            if (/\/cart\/add/.test(e.name)) bump();
          });
        }).observe({ type: 'resource', buffered: false });
      } catch (err) { /* browser vechi */ }
    }
  }

  /* ---------- Meniu mobil: intrare in cascada ---------- */
  if (has('cf-menu')) {
    var drawer = document.querySelector('.mobile--side-drawer');
    if (drawer) {
      drawer.querySelectorAll('.mobile-menu--list > li').forEach(function (li, i) {
        li.style.setProperty('--i', Math.min(i, 12));
      });
      var syncOpen = function () {
        var open = drawer.classList.contains('active') || drawer.classList.contains('is-open') ||
          drawer.hasAttribute('open') || drawer.classList.contains('open') ||
          getComputedStyle(drawer).visibility === 'visible' && getComputedStyle(drawer).opacity !== '0';
        var desired=!!open&&!reduce;if(drawer.classList.contains('cf-open')!==desired)drawer.classList.toggle('cf-open',desired);
      };
      new MutationObserver(syncOpen).observe(drawer, { attributes: true, attributeFilter: ['class', 'open', 'style'] });
    }
  }



  /* ---------- Meniu desktop: capsula care aluneca sub linkul activ ---------- */
  if (has('cf-menu') && finePointer && !reduce) {
    var nav = document.querySelector('.header--navigation');
    if (nav) {
      body.classList.add('cf-nav-js');
      var pill = document.createElement('span');
      pill.className = 'cf-nav-pill';
      pill.setAttribute('aria-hidden', 'true');
      nav.appendChild(pill);
      var place = function (link) {
        var nr = nav.getBoundingClientRect();
        var lr = link.getBoundingClientRect();
        pill.style.width = lr.width + 'px';
        pill.style.height = lr.height + 'px';
        pill.style.transform = 'translate(' + (lr.left - nr.left) + 'px,' + (lr.top - nr.top) + 'px)';
        pill.classList.add('is-on');
      };
      nav.querySelectorAll('.header--menu-link').forEach(function (link) {
        link.addEventListener('pointerenter', function () { place(link); });
      });
      nav.addEventListener('pointerleave', function () {
        var open = nav.querySelector('.header--menu-item.active > .header--menu-link');
        if (open) place(open); else pill.classList.remove('is-on');
      });
    }
  }


  /* ---------- Meniu HUD: efect de decodare a textului la hover ---------- */
  if (has('cf-nav-hud') && finePointer && !reduce) {
    var GLYPHS = '01#/\<>_+=*%ABCDEFX░▒';
    document.querySelectorAll('.header--navigation .header--menu-link').forEach(function (link) {
      var walker = document.createTreeWalker(link, NodeFilter.SHOW_TEXT, {
        acceptNode: function (n) { return n.nodeValue.trim() ? NodeFilter.FILTER_ACCEPT : NodeFilter.FILTER_REJECT; }
      });
      var node = walker.nextNode();
      if (!node) return;
      var original = node.nodeValue;
      var timer = 0;
      link.addEventListener('pointerenter', function () {
        clearInterval(timer);
        var frame = 0, total = 14;
        timer = setInterval(function () {
          frame++;
          var reveal = Math.floor(original.length * frame / total);
          var out = '';
          for (var i = 0; i < original.length; i++) {
            var ch = original[i];
            out += (i < reveal || ch === ' ' || ch === '/') ? ch : GLYPHS[(Math.random() * GLYPHS.length) | 0];
          }
          node.nodeValue = out;
          if (frame >= total) { clearInterval(timer); node.nodeValue = original; }
        }, 28);
      });
      link.addEventListener('pointerleave', function () { clearInterval(timer); node.nodeValue = original; });
    });
  }

  /* ---------- Dock mobil: pozitia lui pentru mascota (--cf-dock-top-px + evenimentul cf:dock) ---------- */
  (function () {
    var dock = document.querySelector('.cf-dock');
    var root = document.documentElement, last = '', raf = 0;
    function measure() {
      raf = 0;
      var info = { visible: false, top: 0, left: 0, right: 0, height: 0 };
      if (dock && getComputedStyle(dock).display !== 'none') {
        var r = dock.getBoundingClientRect(), vh = window.innerHeight;
        if (r.height > 0 && r.top < vh - 2) info = { visible: true, top: r.top, left: r.left, right: r.right, height: r.height };
      }
      var px = info.visible ? Math.max(0, Math.round(window.innerHeight - info.top)) : 0;
      var key = px + '|' + Math.round(info.left) + '|' + Math.round(info.right);
      if (key === last) return;
      last = key;
      root.style.setProperty('--cf-dock-top-px', px + 'px');
      window.dispatchEvent(new CustomEvent('cf:dock', { detail: info }));
    }
    /* 21.10.2026 viteza (cerere coordonator): measure citeste stil + pozitie (recalculare pe ~5.000 de elemente); la derulare era la fiecare cadru.
       Acum cel mult o masurare la 250 ms + una finala dupa oprire. */
    var lastM = 0, trailT = 0;
    function schedule() {
      if (raf) return;
      var gap = 250 - (Date.now() - lastM);
      if (gap > 0) { clearTimeout(trailT); trailT = setTimeout(schedule, gap); return; }
      raf = requestAnimationFrame(function () { lastM = Date.now(); measure(); });
    }
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('orientationchange', schedule);
    if (window.visualViewport) window.visualViewport.addEventListener('resize', schedule, { passive: true });
    if (dock) dock.addEventListener('transitionend', schedule);
    new MutationObserver(schedule).observe(body, { attributes: true, attributeFilter: ['class'] });
    window.addEventListener('scroll', schedule, { passive: true });
    measure();
    window.CoriaDock = { measure: function () { last = ''; measure(); } };
  })();

  /* ---------- Dock mobil: animatie la atingere ---------- */
  document.addEventListener('pointerdown', function (ev) {
    var it = ev.target.closest && ev.target.closest('.cf-dock__item');
    if (!it || it.classList.contains('cf-dock__item--main')) return;
    it.classList.remove('cf-tap');
    void it.offsetWidth;
    it.classList.add('cf-tap');
    clearTimeout(it.__cfTap);
    it.__cfTap = setTimeout(function () { it.classList.remove('cf-tap'); }, 700);
  }, { passive: true });

  /* ---------- Dock mobil ---------- */
  function clickFirst(selectors) {
    for (var i = 0; i < selectors.length; i++) {
      var el = document.querySelector(selectors[i]);
      if (el) { el.click(); return true; }
    }
    return false;
  }
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('[data-cf-dock]');
    if (!btn) return;
    var kind = btn.getAttribute('data-cf-dock');
    // deschidem dupa ce se termina clicul, altfel sertarul il vede ca 'clic in afara' si se inchide imediat
    ev.preventDefault();
    setTimeout(function () { dockOpen(kind); }, 0);
  });
  function dockOpen(kind) {
    if (kind === 'menu') {
      clickFirst(['[data-cm26-sheet]', '.hamburger--toggler', '.mobile-toggler']) || (location.href = route('collections'));
    } else if (kind === 'search') {
      clickFirst(['[data-cm26-msearch]', '.header--icon-item.search .header--icon-link', '.header--icon-item.search a', '[data-source="search-drawer"]']) || (location.href = route('search'));
    } else if (kind === 'cart') {
      clickFirst(['#cart-count-icon', '.header--icon-item.cart .header--icon-link', '[data-source="cart-drawer"]']) || (location.href = route('cart'));
    }
  }

  function refreshCartCount() {
    var badges = document.querySelectorAll('[data-cf-cart-count]');
    if (!badges.length) return;
    (window.coriaCartJsShared ? window.coriaCartJsShared() : fetch(route('cart.js'), { credentials: 'same-origin' }).then(function (r) { return r.json(); }))
      .then(function (c) {
        badges.forEach(function (b) {
          b.textContent = c.item_count;
          b.hidden = !c.item_count;
        });
      })
      .catch(function () {});
  }
  if (window.PerformanceObserver) {
    try {
      new PerformanceObserver(function (list) {
        var hit = list.getEntries().some(function (e) { return /\/cart\/(add|change|update|clear)/.test(e.name); });
        if (hit) setTimeout(refreshCartCount, 250);
      }).observe({ type: 'resource', buffered: false });
    } catch (err) {}
  }


  /* ---------- Meniu: pagina curenta marcata + extra in meniul de pe telefon ---------- */
  (function () {
    var here = location.pathname.replace(/\/$/, '');
    document.querySelectorAll('.header--navigation a[href], .mobile--side-drawer a[href]').forEach(function (a) {
      var h = (a.getAttribute('href') || '').replace(/\/$/, '');
      if (h && h !== '' && h !== '/' && (here === h || here.indexOf(h + '/') === 0)) {
        a.classList.add('cf-current');
        var top = a.closest('.header--menu-item, .mobile-menu--list > li');
        if (top) top.classList.add('cf-current-branch');
      }
    });
    var drawer = document.querySelector('.mobile--side-drawer .side--drawer-body');
    if (!drawer || drawer.querySelector('.cf-mm-search')) return;
    var ICON = {
      search: '<svg viewBox="0 0 24 24"><circle cx="11" cy="11" r="6.5"/><path d="m16 16 4.5 4.5"/></svg>',
      user: '<svg viewBox="0 0 24 24"><circle cx="12" cy="8" r="4"/><path d="M4.5 20.5c1.2-3.6 4-5.5 7.5-5.5s6.3 1.9 7.5 5.5"/></svg>',
      bag: '<svg viewBox="0 0 24 24"><path d="M5 8h14l-1.2 11.2a1.5 1.5 0 0 1-1.5 1.3H7.7a1.5 1.5 0 0 1-1.5-1.3z"/><path d="M8.5 8V7a3.5 3.5 0 0 1 7 0v1"/></svg>',
      ai: '<svg viewBox="0 0 24 24"><path d="M12 3l1.8 4.7L18.5 9.5l-4.7 1.8L12 16l-1.8-4.7L5.5 9.5l4.7-1.8z"/><path d="M19 15l.8 2.2L22 18l-2.2.8L19 21l-.8-2.2L16 18l2.2-.8z"/></svg>',
      chat: '<svg viewBox="0 0 24 24"><path d="M4 5h16v11H9l-5 4z"/></svg>'
    };
    var search = document.createElement('button');
    search.type = 'button';
    search.className = 'cf-mm-search';
    search.innerHTML = '<i>' + ICON.search + '</i><span>' + tx('search', 'Cauta in Coria...') + '</span><kbd>AI</kbd>';
    search.addEventListener('click', function () {
      var close = document.querySelector('.mobile--side-drawer .drawer-close');
      if (close) close.click();
      setTimeout(function () {
        clickFirst(['.header--icon-item.search .header--icon-link', '[data-source="search-drawer"]']) || (location.href = route('search'));
      }, 250);
    });
    drawer.insertBefore(search, drawer.firstChild);
    var quick = document.createElement('div');
    quick.className = 'cf-mm-quick';
    quick.innerHTML =
      '<a href="'+route('account')+'">' + ICON.user + '<span>' + tx('account', 'Cont') + '</span></a>' +
      '<button type="button" data-q="cart">' + ICON.bag + '<span>' + tx('cart', 'Cos') + '</span></button>' +
      '<button type="button" data-q="ai">' + ICON.ai + '<span>' + tx('ai', 'Asistent') + '</span></button>' +
      '<a href="'+route('pages/contact')+'">' + ICON.chat + '<span>' + tx('contact', 'Contact') + '</span></a>';
    quick.addEventListener('click', function (ev) {
      var b = ev.target.closest('[data-q]');
      if (!b) return;
      var close = document.querySelector('.mobile--side-drawer .drawer-close');
      if (close) close.click();
      setTimeout(function () {
        if (b.getAttribute('data-q') === 'cart') clickFirst(['#cart-count-icon']) || (location.href = route('cart'));
        else { var fab = document.getElementById('coria-fab'); if(window.CoriaAssistantBridge)window.CoriaAssistantBridge.open();else if (fab) fab.click(); }
      }, 250);
    });
    drawer.appendChild(quick);
  })();

  /* ---------- Bento: deschide Asistentul Coria ---------- */
  document.addEventListener('click', function (ev) {
    var t = ev.target.closest && ev.target.closest('[data-cf-open-assistant]');
    if (!t) return;
    ev.preventDefault();
    var fab = document.getElementById('coria-fab');
    if(window.CoriaAssistantBridge)window.CoriaAssistantBridge.open();else if (fab) fab.click();
  });

  /* ---------- Hero: animatiile se opresc cand hero nu e pe ecran ---------- */
  if ('IntersectionObserver' in window) {
    document.querySelectorAll('[data-cf-hero]').forEach(function (h) {
      new IntersectionObserver(function (en) { h.classList.toggle('cf-off', !en[0].isIntersecting); }).observe(h);
    });
  }

  /* ---------- Hero: parallax la mouse ---------- */
  if (finePointer && !reduce) {
    document.querySelectorAll('[data-cf-hero]').forEach(function (hero) {
      var raf = 0;
      hero.addEventListener('pointermove', function (ev) {
        if (raf) return;
        raf = requestAnimationFrame(function () {
          raf = 0;
          var r = hero.getBoundingClientRect();
          hero.style.setProperty('--cf-px', ((ev.clientX - r.left) / r.width - 0.5).toFixed(3));
          hero.style.setProperty('--cf-py', ((ev.clientY - r.top) / r.height - 0.5).toFixed(3));
        });
      });
      hero.addEventListener('pointerleave', function () {
        hero.style.setProperty('--cf-px', 0);
        hero.style.setProperty('--cf-py', 0);
      });
    });
  }


  /* ---------- Hero: particule luminoase (canvas, se opresc cand nu sunt vizibile) ---------- */
  if (!reduce && !lite && !coarse) {
    document.querySelectorAll('[data-cf-particles]').forEach(function (cv) {
      var ctx = cv.getContext('2d');
      if (!ctx) return;
      var hero = cv.closest('[data-cf-hero]') || cv.parentElement;
      var dark = hero.classList.contains('cf-hero--dark');
      var cs = getComputedStyle(body);
      var acc = (cs.getPropertyValue('--cf-accent-rgb') || '226,165,148').trim();
      var met = (cs.getPropertyValue('--cf-metal-rgb') || '216,188,156').trim();
      var palette = dark ? ['255,244,236', acc, met, '217,198,238'] : [acc, met, '122,90,76'];
      var dpr = Math.min(window.devicePixelRatio || 1, 2);
      var W = 0, H = 0, parts = [], visible = true, mx = -9999, my = -9999, raf = 0;
      function size() {
        var r = cv.getBoundingClientRect();
        W = r.width; H = r.height;
        cv.width = W * dpr; cv.height = H * dpr;
        ctx.setTransform(dpr, 0, 0, dpr, 0, 0);
        var n = Math.round(Math.min(45, (W * H) / 26000));
        parts = [];
        for (var i = 0; i < n; i++) {
          parts.push({
            x: Math.random() * W, y: Math.random() * H,
            r: Math.random() * 1.8 + .4,
            vx: (Math.random() - .5) * .15, vy: -(Math.random() * .35 + .05),
            c: palette[i % palette.length], t: Math.random() * 6.28
          });
        }
      }
      var last = 0;
      function frame(t) {
        raf = 0;
        if (!visible || document.hidden || !cv.isConnected) return;
        if (t && t - last < 33) { raf = requestAnimationFrame(frame); return; }
        last = t || 0;
        ctx.clearRect(0, 0, W, H);
        for (var i = 0; i < parts.length; i++) {
          var p = parts[i];
          var dx = p.x - mx, dy = p.y - my, d2 = dx * dx + dy * dy;
          if (d2 < 14400) { var f = (14400 - d2) / 14400 * .9; p.x += dx / 60 * f; p.y += dy / 60 * f; }
          p.x += p.vx; p.y += p.vy; p.t += .03;
          if (p.y < -10) { p.y = H + 10; p.x = Math.random() * W; }
          if (p.x < -10) p.x = W + 10; else if (p.x > W + 10) p.x = -10;
          var a = (Math.sin(p.t) * .35 + .55) * (dark ? .9 : .6);
          ctx.beginPath();
          ctx.fillStyle = 'rgba(' + p.c + ',' + a.toFixed(3) + ')';
          ctx.arc(p.x, p.y, p.r, 0, 6.283);
          ctx.fill();
        }
        raf = requestAnimationFrame(frame);
      }
      size();
      document.addEventListener('visibilitychange',function(){if(!document.hidden&&visible&&cv.isConnected&&!raf)raf=requestAnimationFrame(frame);});
      window.addEventListener('resize', function () { size(); }, { passive: true });
      hero.addEventListener('pointermove', function (ev) {
        var r = cv.getBoundingClientRect();
        mx = ev.clientX - r.left; my = ev.clientY - r.top;
      }, { passive: true });
      hero.addEventListener('pointerleave', function () { mx = my = -9999; });
      if ('IntersectionObserver' in window) {
        new IntersectionObserver(function (en) {
          visible = en[0].isIntersecting;
          if (visible && !raf) raf = requestAnimationFrame(frame);
        }).observe(hero);
      }
      raf = requestAnimationFrame(frame);
    });
  }

  /* ---------- Cursor luminos ---------- */
  if (has('cf-cursor') && finePointer && !reduce && !lite) {
    var glow = document.createElement('div');
    var ring = document.createElement('div');
    glow.className = 'cf-cursor-glow';
    ring.className = 'cf-cursor-ring';
    glow.setAttribute('aria-hidden', 'true');
    ring.setAttribute('aria-hidden', 'true');
    body.appendChild(glow);
    body.appendChild(ring);
    var mx = innerWidth / 2, my = innerHeight / 2, gx = mx, gy = my, rx = mx, ry = my, running = false;
    var loop = function () {
      gx += (mx - gx) * 0.12; gy += (my - gy) * 0.12;
      rx += (mx - rx) * 0.35; ry += (my - ry) * 0.35;
      glow.style.transform = 'translate3d(' + gx + 'px,' + gy + 'px,0)';
      ring.style.transform = 'translate3d(' + rx + 'px,' + ry + 'px,0)';
      if (Math.abs(mx - gx) + Math.abs(my - gy) > 0.5) requestAnimationFrame(loop); else running = false;
    };
    document.addEventListener('pointermove', function (ev) {
      if (ev.pointerType !== 'mouse') return;
      mx = ev.clientX; my = ev.clientY;
      body.classList.add('cf-cursor-on');
      var link = ev.target.closest && ev.target.closest('a, button, [role="button"], input, select, label, .swiper-button');
      ring.classList.toggle('is-link', !!link);
      if (!running) { running = true; requestAnimationFrame(loop); }
    }, { passive: true });
    document.addEventListener('pointerleave', function () { body.classList.remove('cf-cursor-on'); });
    window.addEventListener('scroll', function () { body.classList.remove('cf-cursor-on'); }, { passive: true });
  }

  /* ---------- Intro cu logo (o data pe sesiune) ---------- */
  if (has('cf-intro') && !reduce) {
    var seen = false;
    try { seen = sessionStorage.getItem('cf-intro') === '1'; sessionStorage.setItem('cf-intro', '1'); } catch (e) {}
    var logo = document.querySelector('.header--logo-img:not(.transparent-logo-img)');
    if (!seen && logo) {
      var veil = document.createElement('div');
      veil.className = 'cf-intro-veil';
      var img = document.createElement('img');
      img.src = logo.currentSrc || logo.src;
      img.alt = '';
      veil.appendChild(img);
      body.appendChild(veil);
      setTimeout(function () { veil.classList.add('is-out'); }, 900);
      setTimeout(function () { veil.remove(); }, 2100);
    }
  }


  /* ---------- Carduri: "Adauga in cos" + cantitate (foloseste formularul temei) ---------- */
  /* 20.10: cosulet de cumparaturi (contur), nu punga plina - aceea semana cu un cos de gunoi */
  var ICON_BAG = '<svg class="cf-basket" viewBox="0 0 24 24" aria-hidden="true" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M3.5 10h17l-1.7 8.3a2 2 0 0 1-2 1.7H7.2a2 2 0 0 1-2-1.7z"/><path d="M8.5 10l3-6"/><path d="M15.5 10l-3-6"/><path d="M9.5 13.5v3.5"/><path d="M14.5 13.5v3.5"/></svg>';
  var ICON_OK = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="m5 12.5 4.5 4.5L19 7.5"/></svg>';
  function readJSON(form, name) {
    var el = form.querySelector('script[data-name="' + name + '"]');
    if (!el) return null;
    try { return JSON.parse(el.textContent); } catch (e) { return null; }
  }
  /* 18.10.2026 viteza: bara „Adauga” se construieste cand cardul ajunge la 800 px de ecran (inainte: pe TOATE cardurile la incarcare,
     cu sute de insertii -> recalculari de stil pe toata pagina). Cardurile din carusele / randuri laterale se construiesc imediat
     (acolo inaltimea randului nu trebuie sa se schimbe la glisare). Cardurile venite prin AJAX trec tot pe aici (MutationObserver -> init). */
  var atcIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (en) {
    en.forEach(function (e) { if (e.isIntersecting) { atcIO.unobserve(e.target); buildOneAtc(e.target); } });
  }, { rootMargin: '800px 0px' }) : null;
  var ATC_IMEDIAT = '.swiper, .swiper-wrapper, [class*="swiper"], .scrolling-collection, .scrolling-collections, .collections-tab--menu-content, .side-drawer, .quickview-product, coria-product-choices, .cf-fy__track, .cf-gal__track';
  function buildCardAtc(root) {
    if (!has('cf-card-atc')) return;
    (root || document).querySelectorAll('.product--card:not([data-cf-atc])').forEach(function (card) {
      if (card.__cfAtcObs) return;
      if (!atcIO || card.closest(ATC_IMEDIAT)) { buildOneAtc(card); return; }
      card.__cfAtcObs = true;
      atcIO.observe(card);
    });
  }
  function buildOneAtc(card) {
    if (card.hasAttribute('data-cf-atc')) return;
    (function () {
      var form = card.querySelector('form[action*="/cart/add"]');
      var submit = form && form.querySelector('button[type="submit"]');
      var detail = card.querySelector('.product--card-detail-content') || card.querySelector('.product--card-detail');
      if (!form || !submit || !detail) return;
      card.setAttribute('data-cf-atc', '');
      var link = card.querySelector('a.product--title, a.product--image');
      var options = readJSON(form, 'product-options') || [];
      var multi = options.some(function (o) { return o.values && o.values.length > 1; });
      var inventories=readJSON(form,'product-inventories')||[];var nativeVariant=form.querySelector('[name="id"]');
      var inv=inventories.find(function(v){return nativeVariant&&String(v.id)===String(nativeVariant.value);})||inventories[0];
      var rules=(inv&&inv.quantity_rule)||{},minimum=Math.max(1,Number(rules.min)||1),increment=Math.max(1,Number(rules.increment)||1);
      if(form.querySelector('[name^="properties["],[name="selling_plan"]')||card.querySelector('[data-cf-requires-plan="true"]'))multi=true;
      var max = Number.MAX_SAFE_INTEGER;
      if (inv && inv.inventory_management === 'shopify' && inv.inventory_policy === 'deny') {
        var q = parseInt(inv.inventory_quantity, 10);
        if (!isNaN(q) && q > 0) max = q;
      }
      if(rules.max)max=Math.min(max,Number(rules.max));
      var bar = document.createElement('div');
      bar.className = 'cf-atc';
      if (submit.disabled) {
        bar.innerHTML = '<span class="cf-atc__btn is-disabled">' + tx('soldout', 'Stoc epuizat') + '</span>';
      } else if (multi) {
        bar.innerHTML = '<a class="cf-atc__btn" href="' + (link ? link.getAttribute('href') : '#') + '"><span>' + tx('variant', 'Alege varianta') + '</span><i>' + ICON_BAG + '</i></a>';
      } else {
        bar.innerHTML =
          '<div class="cf-atc__qty" role="group" aria-label="Cantitate">' +
            '<button type="button" class="cf-atc__step" data-step="-1" aria-label="Scade cantitatea">−</button>' +
            '<input class="cf-atc__input" type="number" inputmode="numeric" min="'+minimum+'" step="'+increment+'" max="' + max + '" value="'+minimum+'" aria-label="Cantitate">' +
            '<button type="button" class="cf-atc__step" data-step="1" aria-label="Creste cantitatea">+</button>' +
          '</div>' +
          '<button type="button" class="cf-atc__btn" data-cf-add aria-label="' + String(tx('add', 'Adauga in cos')).replace(/"/g, '&quot;') + '"><span>' + addLbl() + '</span><i>' + ICON_BAG + '</i></button>';
        var input = bar.querySelector('.cf-atc__input');
        var clamp = function (v) { v=Number(v);if(!Number.isFinite(v))v=minimum;v=minimum+Math.floor(Math.max(0,v-minimum)/increment)*increment;return Math.max(minimum,Math.min(v,minimum+Math.floor((max-minimum)/increment)*increment)); };
        bar.querySelector('.cf-atc__qty').addEventListener('click', function (ev) {
          ev.preventDefault();
          ev.stopPropagation();
          var step = ev.target.closest('[data-step]');
          if (!step) return;
          input.value = clamp(+input.value + +step.getAttribute('data-step')*increment);
          input.classList.remove('cf-tick'); void input.offsetWidth; input.classList.add('cf-tick');
        });
        bar.addEventListener('click', function (ev) {
          var add = ev.target.closest('[data-cf-add]');
          if (!add || add.classList.contains('is-busy')) return;
          ev.preventDefault();
          var qtyField = form.querySelector('input[name="quantity"]');
          if (!qtyField) {
            qtyField = document.createElement('input');
            qtyField.type = 'hidden';
            qtyField.name = 'quantity';
            form.appendChild(qtyField);
          }
          qtyField.value = clamp(input.value);
          add.classList.add('is-busy');
          var label = add.querySelector('span');
          var icon = add.querySelector('i');
          var settled = false;
          var reset = function (delay) {
            setTimeout(function () {
              add.classList.remove('is-done', 'is-error');
              label.innerHTML = addLbl();
              icon.innerHTML = ICON_BAG;
            }, delay);
          };
          var finish = function (ok) {
            if (settled) return;
            settled = true;
            clearTimeout(guard);
            form.removeEventListener('coria:cart-result',onCartResult);
            add.classList.remove('is-busy');
            if (ok) {
              flyToCart(card.querySelector('.product--image img'), card.style.getPropertyValue('--cf-tint'));
              add.classList.add('is-done');
              label.textContent = tx('added', 'Adaugat');
              icon.innerHTML = ICON_OK;
              input.value = minimum;
              refreshCartCount();
            } else {
              add.classList.add('is-error');
              label.textContent = tx('error', 'Incearca din nou');
            }
            reset(ok ? 1800 : 2600);
          };
          var onCartResult=function(event){if(event.target!==form)return;finish(!!event.detail.ok);};
          form.addEventListener('coria:cart-result',onCartResult);
          var guard=setTimeout(function(){finish(false);label.textContent='Verifică în coș';},15000);
          if(submit.disabled||submit.getAttribute('aria-disabled')==='true'){finish(false);return;}
          submit.click();
        });
        input.addEventListener('change', function () { input.value = clamp(input.value); });
      }
      bar.addEventListener('click', function (ev) { if (!ev.target.closest('a')) ev.stopPropagation(); });
      detail.appendChild(bar);
      tintLazy(card);
      // pret: cifrele mari, moneda discreta
      card.querySelectorAll('.product--pricing .money').forEach(function (m) {
        if (m.querySelector('.cf-num')) return;
        var t = (m.textContent || '').trim();
        var mm = t.match(/^([^\d]*?)([\d.,\s]+\d)\s*([^\d]*)$/);
        if (!mm) return;
        m.innerHTML = (mm[1] ? '<span class="cf-cur">' + mm[1].trim() + '</span>' : '') +
          '<span class="cf-num">' + mm[2].trim() + '</span>' +
          (mm[3] ? '<span class="cf-cur">' + mm[3].trim() + '</span>' : '');
      });
      // cantitatea sta discret pe randul pretului
      var qtyBox = bar.querySelector('.cf-atc__qty');
      var pricing = card.querySelector('.product--pricing');
      if (qtyBox && pricing) {
        var row = document.createElement('div');
        row.className = 'cf-price-row';
        pricing.parentNode.insertBefore(row, pricing);
        row.appendChild(pricing);
        row.appendChild(qtyBox);
      }
    })();
  }


  /* ---------- Colectie: butonul "Filtre" pe acelasi rand cu Pret / Disponibilitate / Sortare ---------- */
  function mergeFilterButton() {
    var row = document.querySelector('.horizontal-filters--main');
    /* 20.10.2026: butonul poate veni deja din server (data-cf-ssr, fara CLS); il preluam o singura data */
    var ssr = document.querySelector('.cf-filter-btn[data-cf-ssr]');
    if (!row || (document.querySelector('.cf-filter-btn') && !ssr)) return;
    var appLink = document.querySelector('.cloud-search-page-controls__filters-link');
    var themeBtn = document.querySelector('.collection--topbar .filter-toggle-button');
    var target = appLink || themeBtn;
    if (!target && !ssr) return;
    var btn = ssr;
    if (btn) btn.removeAttribute('data-cf-ssr');
    else {
      btn = document.createElement('button');
      btn.type = 'button';
      btn.className = 'cf-filter-btn';
      btn.innerHTML = '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M4 7h10M18 7h2M4 17h4M12 17h8"/><circle cx="16" cy="7" r="2"/><circle cx="10" cy="17" r="2"/></svg><span>' + tx('filters', 'Filtre') + '</span>';
    }
    btn.addEventListener('click', function (ev) {
      ev.preventDefault();
      var live = document.querySelector('.cloud-search-page-controls__filters-link') ||
        document.querySelector('.collection--topbar .filter-toggle-button');
      if (live) live.click();
    });
    if (btn.parentNode !== row) row.insertBefore(btn, row.firstChild);
    // pe telefon butonul sta in bara lipita sus, in locul butonului temei
    var topbar = document.querySelector('.collection--topbar');
    if (topbar && window.matchMedia('(max-width: 767px)').matches) {
      topbar.insertBefore(btn, topbar.firstChild);
      body.classList.add('cf-filters-topbar');
    }
    if (appLink) body.classList.add('cf-filters-merged');
  }


  /* ---------- Carduri: linia de sub nume preia culoarea produsului din poza ---------- */
  var tintCache = {};
  var tintIO = 'IntersectionObserver' in window ? new IntersectionObserver(function (en) {
    en.forEach(function (e) { if (e.isIntersecting) { tintIO.unobserve(e.target); tintCard(e.target); } });
  }, { rootMargin: '200px 0px' }) : null;
  function tintLazy(card) { if (tintIO) tintIO.observe(card); else tintCard(card); }
  function tintCard(card, imgSel) {
    var img = card.querySelector(imgSel || '.product--image img');
    if (!img) return;
    var src = img.currentSrc || img.src || '';
    if (!src || src.indexOf('data:') === 0) {
      img.addEventListener('load', function () { tintCard(card, imgSel); }, { once: true });
      return;
    }
    var key = src.split('?')[0];
    var apply = function (rgb) { if (rgb) card.style.setProperty('--cf-tint', rgb); };
    if (tintCache[key] !== undefined) { apply(tintCache[key]); return; }
    var probe = new Image();
    probe.crossOrigin = 'anonymous';
    probe.onload = function () {
      try {
        var c = document.createElement('canvas');
        c.width = c.height = 32;
        var x = c.getContext('2d', { willReadFrequently: true });
        x.drawImage(probe, 0, 0, 32, 32);
        var d = x.getImageData(0, 0, 32, 32).data;
        var best = null, bestScore = 0, buckets = {};
        for (var i = 0; i < d.length; i += 4) {
          var r = d[i], g = d[i + 1], b = d[i + 2], a = d[i + 3];
          if (a < 200) continue;
          var mx = Math.max(r, g, b), mn = Math.min(r, g, b);
          var sat = mx === 0 ? 0 : (mx - mn) / mx;
          if (mx > 242 && sat < .12) continue;      // fundal alb
          if (mx < 28) continue;                      // negru (sticla)
          if (sat < .18) continue;                    // gri / bej neutru
          var k = (r >> 5) + ',' + (g >> 5) + ',' + (b >> 5);
          var bk = buckets[k] || (buckets[k] = { n: 0, r: 0, g: 0, b: 0, s: 0 });
          bk.n++; bk.r += r; bk.g += g; bk.b += b; bk.s += sat;
        }
        Object.keys(buckets).forEach(function (k) {
          var bk = buckets[k];
          var score = bk.n * (0.6 + bk.s / bk.n);
          if (score > bestScore) { bestScore = score; best = bk; }
        });
        var rgb = best && best.n >= 6 ? [Math.round(best.r / best.n), Math.round(best.g / best.n), Math.round(best.b / best.n)].join(', ') : null;
        tintCache[key] = rgb;
        apply(rgb);
      } catch (e) { tintCache[key] = null; }
    };
    probe.onerror = function () { tintCache[key] = null; };
    probe.src = key + (key.indexOf('?') > -1 ? '&' : '?') + 'width=64';
  }


  /* ---------- Tranzitie: poza cardului "zboara" in pagina produsului ---------- */
  document.addEventListener('click', function (ev) {
    var a = ev.target.closest && ev.target.closest('.product--card a[href*="/products/"]');
    if (!a || ev.metaKey || ev.ctrlKey || ev.shiftKey) return;
    var card = a.closest('.product--card');
    var img = card && card.querySelector('.product--image img');
    if (!img) return;
    document.querySelectorAll('[style*="cf-product"]').forEach(function (el) { el.style.viewTransitionName = ''; });
    /* 20.10.2026: pe pagina de produs, prima poza din galerie are deja numele din CSS (coria-future.css); daca dai click pe un
       card de jos (produse asemanatoare), doua elemente ar avea „cf-product” -> „Unexpected duplicate view-transition-name”
       si tranzitia era anulata. Ii scoatem numele inainte sa-l dam pozei din card. */
    document.querySelectorAll('.section-main-product media-gallery .swiper-slide:first-child .media img').forEach(function (el) { if (el !== img) el.style.viewTransitionName = 'none'; });
    img.style.viewTransitionName = 'cf-product';
  }, true);

  /* ---------- Zbor spre cos ---------- */
  function flyToCart(fromImg, tint) {
    if (!fromImg || reduce || !fromImg.animate) return;
    var target = null;
    var dockCart = document.querySelector('.cf-dock [data-cf-dock="cart"]');
    if (dockCart && dockCart.offsetParent) target = dockCart;
    if (!target) target = document.getElementById('cart-count-icon');
    if (!target) return;
    var a = fromImg.getBoundingClientRect(), b = target.getBoundingClientRect();
    if (!a.width || !b.width) return;
    var fly = document.createElement('div');
    fly.className = 'cf-fly';
    if (tint) fly.style.setProperty('--cf-tint', tint);
    var size = Math.min(a.width, a.height, 160);
    fly.style.width = size + 'px';
    fly.style.height = size + 'px';
    fly.style.left = (a.left + a.width / 2 - size / 2) + 'px';
    fly.style.top = (a.top + a.height / 2 - size / 2) + 'px';
    var im = document.createElement('img');
    im.src = fromImg.currentSrc || fromImg.src;
    im.alt = '';
    fly.appendChild(im);
    body.appendChild(fly);
    var dx = b.left + b.width / 2 - (a.left + a.width / 2);
    var dy = b.top + b.height / 2 - (a.top + a.height / 2);
    var anim = fly.animate([
      { transform: 'translate(0,0) scale(1)', opacity: 1, borderRadius: '16px' },
      { transform: 'translate(' + dx * 0.55 + 'px,' + (dy * 0.35 - 80) + 'px) scale(.55)', opacity: 1, borderRadius: '40%', offset: 0.55 },
      { transform: 'translate(' + dx + 'px,' + dy + 'px) scale(.12)', opacity: .2, borderRadius: '50%' }
    ], { duration: 850, easing: 'cubic-bezier(.5,0,.25,1)' });
    anim.onfinish = function () { fly.remove(); };
  }
  document.addEventListener('click', function (ev) {
    var btn = ev.target.closest && ev.target.closest('.section-main-product .product-checkout-buttons button[type="submit"]:not([disabled])');
    if (!btn) return;
    var pdp = btn.closest('.section-main-product');
    var img = pdp && (pdp.querySelector('media-gallery .swiper-slide-active img') || pdp.querySelector('media-gallery img'));
    flyToCart(img, pdp && pdp.style.getPropertyValue('--cf-tint'));
  }, true);


  /* ---------- Footer pe telefon: coloanele pornesc deschise ---------- */
  document.querySelectorAll('.section-footer details.footer--menu').forEach(function (d) { d.setAttribute('open', ''); });

  /* ---------- Init + continut incarcat dinamic (filtre, "vezi mai multe") ---------- */
  function init(root) {
    mergeFilterButton();
    var pdp = document.querySelector('.section-main-product');
    if (pdp && !pdp.hasAttribute('data-cf-tinted')) {
      pdp.setAttribute('data-cf-tinted', '');
      tintCard(pdp, 'media-gallery img');
      // descrierea / acordeonul se muta sub produs, pe toata latimea paginii
      var acc = pdp.querySelector('.product--detail-accordion');
      var wrap = pdp.querySelector('.product--wrapper');
      if (acc && wrap && !pdp.querySelector('.cf-pdp-details')) {
        var holder = document.createElement('div');
        holder.className = 'cf-pdp-details';
        holder.innerHTML = '<span class="cf-pdp-details__label">' + getComputedStyle(document.documentElement).getPropertyValue('--cf-t-details').trim().replace(/^"|"$/g, '') + '</span>';
        wrap.parentNode.insertBefore(holder, wrap.nextSibling);
        holder.appendChild(acc);
        // v22.31: descrierea nu se mai deschide singura (cererea userului: pagina mai compacta, clienta deschide daca vrea)
        // subtitlu mare doar daca primul paragraf e scurt (merge pe orice descriere)
        var markLead = function () {
          var body = acc.querySelector('.station-tabs-tabcontent') || acc.querySelector('.product-accordion--content-body');
          if (!body || body.querySelector('.cf-lead')) return;
          var firstEl = body.firstElementChild;
          while (firstEl && !firstEl.textContent.trim()) firstEl = firstEl.nextElementSibling;
          if (firstEl && firstEl.tagName === 'P') {
            var len = firstEl.textContent.trim().length;
            if (len > 0 && len <= 110) firstEl.classList.add('cf-lead');
          }
        };
        markLead();
        setTimeout(markLead, 1400);
        // fila aplicatiei Tabs Studio porneste deschisa
        setTimeout(function () {
          var tab = acc.querySelector('.station-tabs-tab');
          var panel = acc.querySelector('.station-tabs-tabpanel');
          if (tab && panel && panel.offsetHeight < 20) tab.click();
        }, 1200);
      }
      // documentele apar o singura data (in panoul produsului)
      setTimeout(function () {
        var docs = document.querySelectorAll('.tigren-product-attachments');
        if (docs.length > 1 && pdp.querySelector('.product-info-details .tigren-product-attachments')) {
          docs.forEach(function (d) { if (!d.closest('.product-info-details')) d.style.display = 'none'; });
        }
      }, 1500);
    }
    buildCardAtc(root);
    prepReveal(root);
    bindCards(root);
  }
  init();
  var pending = null;
  new MutationObserver(function (muts) {
    var added = muts.some(function (m) {
      for (var i = 0; i < m.addedNodes.length; i++) {
        var n = m.addedNodes[i];
        if (n.nodeType === 1 && (n.matches('.product--card, ' + REVEAL) || n.querySelector('.product--card, ' + REVEAL))) return true;
      }
      return false;
    });
    if (!added) return;
    clearTimeout(pending);
    pending = setTimeout(function () { init(document.getElementById('MainContent')); }, 120);
  }).observe(document.getElementById('MainContent') || body, { childList: true, subtree: true });

  // siguranta: daca ceva ramane ascuns (ex. element iesit din viewport printr-un slider), il aratam
  window.addEventListener('load', function () {
    setTimeout(function () {
      var vh2 = window.innerHeight, show = [];
      document.querySelectorAll('.cf-rv:not(.cf-in)').forEach(function (el) {
        var r = el.getBoundingClientRect();
        if (r.top < vh2 && r.bottom > 0) show.push(el);
      });
      show.forEach(function (el) { el.classList.add('cf-in'); });
    }, 1500);
  });
})();
